import { Component } from '@angular/core';
import { AgChartsModule } from 'ag-charts-angular';
import { AgChartOptions } from 'ag-charts-community';

@Component({
  selector: 'app-inventory',
  templateUrl: './inventory.component.html',
  styleUrl: './inventory.component.scss',
  standalone: true,
  imports: [AgChartsModule],
})
export class InventoryComponent {
  chartOptions: AgChartOptions = {
    title: { text: 'Stacked Bar Chart Example' },
    data: [
      { month: 'Jan', apples: 100, oranges: 50 },
      { month: 'Feb', apples: 120, oranges: 80 },
      { month: 'Mar', apples: 90, oranges: 60 },
      { month: 'Apr', apples: 140, oranges: 100 },
      { month: 'May', apples: 110, oranges: 70 },
    ],
    series: [
      {
        type: 'bar',
        xKey: 'month',
        yKey: 'apples',
        yName: 'Apples',
        stacked: true,
        fill: '#4caf50' // green
      },
      {
        type: 'bar',
        xKey: 'month',
        yKey: 'oranges',
        yName: 'Oranges',
        stacked: true,
        fill: '#ff9800' // orange
      },
    ],
    axes: [
      {
        type: 'category',
        position: 'bottom',
        title: { text: 'Month' }, // X axis legend
      },
      {
        type: 'number',
        position: 'left',
        title: { text: 'Quantity' }, // Y axis legend
      },
    ],
  };

  chartOptions2: AgChartOptions = {
    title: { text: 'Monthly Comparison: 2024 vs 2025' },
    data: [
      { month: 'Jan', year2024: 120, year2025: 150 },
      { month: 'Feb', year2024: 100, year2025: 130 },
      { month: 'Mar', year2024: 140, year2025: 160 },
      { month: 'Apr', year2024: 130, year2025: 170 },
      { month: 'May', year2024: 110, year2025: 120 },
      { month: 'Jun', year2024: 115, year2025: 125 },
      { month: 'Jul', year2024: 125, year2025: 135 },
      { month: 'Aug', year2024: 135, year2025: 145 },
      { month: 'Sep', year2024: 145, year2025: 155 },
      { month: 'Oct', year2024: 155, year2025: 165 },
      { month: 'Nov', year2024: 165, year2025: 175 },
      { month: 'Dec', year2024: 175, year2025: 185 },
    ],
    series: [
      {
        type: 'bar',
        xKey: 'month',
        yKey: 'year2024',
        yName: '2024',
      },
      {
        type: 'bar',
        xKey: 'month',
        yKey: 'year2025',
        yName: '2025',
      },
    ],
    axes: [
      {
        type: 'category',
        position: 'bottom',
        title: { text: 'Month' }, // X axis legend
      },
      {
        type: 'number',
        position: 'left',
        title: { text: 'Quantity' }, // Y axis legend
      },
    ],
  };
}
